import { createSlice } from '@reduxjs/toolkit'

const profileStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: null,
    errorMessage: null,
    newDetails: {},
}

const profileSlice = createSlice({
    name: 'account/profile',
    initialState,
    reducers: {
        updateProfileRequest: state => {
            state.status = profileStatus.LOADING
        },
        updateProfileRequestSuccess: (state, action) => {
            state.status = profileStatus.SUCCESS
            state.newDetails = action.payload
        },
        updateProfileRequestError: (state, action) => {
            state.status = profileStatus.FAILURE
            state.errorMessage = action.payload
        },
        reset: state => initialState,
    },
})

const {
    updateProfileRequest,
    updateProfileRequestSuccess,
    updateProfileRequestError,
    reset,
} = profileSlice.actions

export const profileActions = {
    updateProfileRequest,
    updateProfileRequestSuccess,
    updateProfileRequestError,
    reset,
}

export const profileSelectors = {
    isFetching: state => state.accountProfile.status === profileStatus.LOADING,
    hasError: state => state.accountProfile.status === profileStatus.FAILURE,
    success: state => state.accountProfile.status === profileStatus.SUCCESS,
    errorMessage: state => state.accountProfile.errorMessage,
    newDetails: state => state.accountProfile.newDetails,
}

export default profileSlice.reducer
